import { Link } from 'react-router-dom';
import { articles } from '@/mocks/articles';

export default function HeroSection() {
  const topArticle = articles.find((a) => a.isTop) || articles[0];

  return (
    <section className="relative w-full min-h-[520px] md:min-h-[600px] flex items-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src={topArticle.coverImage}
          alt={topArticle.title}
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/50 to-background-50"></div>
      </div>

      <div className="relative z-10 w-full max-w-7xl mx-auto px-4 md:px-6 py-16 md:py-20">
        <div className="max-w-3xl">
          <div className="flex items-center gap-3 mb-4">
            <span className="px-3 py-1 bg-primary-500 text-background-50 text-xs font-semibold rounded-full whitespace-nowrap">
              头条爆料
            </span>
            <span className="text-foreground-400 text-sm whitespace-nowrap">
              <i className="ri-time-line mr-1"></i>{topArticle.publishedAt}
            </span>
            <span className="text-foreground-400 text-sm whitespace-nowrap">
              <i className="ri-eye-line mr-1"></i>{(topArticle.views / 10000).toFixed(1)}万阅读
            </span>
          </div>

          <Link to={`/article/${topArticle.id}`}>
            <h1 className="text-2xl md:text-4xl lg:text-5xl font-heading font-bold text-foreground-50 leading-tight mb-4 hover:text-primary-300 transition-colors">
              {topArticle.title}
            </h1>
          </Link>

          <p className="text-foreground-400 text-sm md:text-base leading-relaxed mb-6 max-w-2xl">
            {topArticle.excerpt}
          </p>

          <div className="flex flex-wrap items-center gap-4">
            <Link
              to={`/article/${topArticle.id}`}
              className="inline-flex items-center gap-2 px-5 py-2.5 bg-primary-500 text-background-50 text-sm font-semibold rounded-full hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
            >
              阅读全文
              <i className="ri-arrow-right-line"></i>
            </Link>
            <Link
              to={`/category/${topArticle.categorySlug}`}
              className="inline-flex items-center gap-1 px-4 py-2.5 bg-background-100/80 text-foreground-300 text-sm rounded-full hover:bg-background-200/80 transition-colors whitespace-nowrap cursor-pointer"
            >
              <i className="ri-folder-line"></i>
              {topArticle.categoryName}
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}